import "./diwali.css";

const END = Date.UTC(2026, 10, 11, 18, 29, 59);

// Shared countdown script from the design file, started once for all slots.
if (typeof window !== "undefined" && !window.__gwdStarted) {
  window.__gwdStarted = true;
  (function () {
    function pad(n) { return (n < 10 ? "0" : "") + n; }
    function tick() {
      var ms = END - Date.now();
      if (ms <= 0) { document.querySelectorAll(".gwd-offer").forEach(function (e) { e.style.display = "none"; }); return; }
      var s = Math.floor(ms / 1000), d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
      var left = d > 0 ? d + "d " + h + "h" : h + "h " + m + "m";
      document.querySelectorAll("[data-gwd-left]").forEach(function (e) { e.textContent = left; });
      document.querySelectorAll("[data-gwd-box]").forEach(function (b) {
        var v = { d: d, h: h, m: m, s: sec };
        b.querySelectorAll("[data-u]").forEach(function (x) { x.textContent = pad(v[x.dataset.u]); });
      });
    }
    tick(); setInterval(tick, 1000);
  })();
}

function initial() {
  const s = Math.max(0, Math.floor((END - Date.now()) / 1000));
  const d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60);
  const p = (n) => (n < 10 ? "0" : "") + n;
  return { left: d > 0 ? `${d}d ${h}h` : `${h}h ${m}m`, d: p(d), h: p(h), m: p(m), s: p(s % 60) };
}

const live = () => Date.now() < END;
const URL = (c) => `https://greenwickfunded.com/pricing?code=DIWALI35&utm_source=terminal&utm_content=${c}`;

export function DiwaliStrip() {
  if (!live()) return null;
  return (
    <a className="gwd-offer gwd-strip" href={URL("chart")} target="_blank" rel="noopener noreferrer" data-testid="diwali-strip">
      <span className="gwd-diya">🪔</span>
      <span className="gwd-t"><b>Diwali offer <em>35% OFF</em></b><small>+100% 1st payout · <i data-gwd-left>{initial().left}</i></small></span>
      <span className="gwd-go">Claim →</span>
    </a>
  );
}

export function DiwaliPill() {
  if (!live()) return null;
  return (
    <a className="gwd-offer gwd-pill" href={URL("dashboard")} target="_blank" rel="noopener noreferrer" data-testid="diwali-pill"><span>
      <i className="gwd-dot"></i><span className="gwd-live">LIVE</span><span>🪔 Diwali <b>35% OFF</b></span><span className="gwd-end">· ends in <span data-gwd-left>{initial().left}</span></span><span className="gwd-arr">→</span>
    </span></a>
  );
}

export function DiwaliCard() {
  if (!live()) return null;
  const t = initial();
  return (
    <a className="gwd-offer gwd-card" href={URL("positions")} target="_blank" rel="noopener noreferrer" data-testid="diwali-card">
      <div className="gwd-diyas"><span>🪔</span><span>🪔</span><span>🪔</span><span>🪔</span><span>🪔</span></div>
      <div className="gwd-slog">Diwali Ho Shaandaar</div>
      <div className="gwd-h">Add another account at <em>35% off</em></div>
      <div className="gwd-sub">Same rules. Just a lower price, till 11 Nov.</div>
      <div className="gwd-perks"><span><b>100%</b> 1st payout</span><span><b>Free</b> printed journal</span><span><b>60 sec</b> setup</span></div>
      <div className="gwd-cd" data-gwd-box><div><b data-u="d">{t.d}</b><small>DAYS</small></div><div><b data-u="h">{t.h}</b><small>HRS</small></div><div><b data-u="m">{t.m}</b><small>MIN</small></div><div><b data-u="s">{t.s}</b><small>SEC</small></div></div>
      <div className="gwd-price">₹5L account <s>₹8,999</s> <b>₹5,849</b></div>
      <span className="gwd-btn">Claim Diwali price →</span>
      <div className="gwd-fine">Code DIWALI35 auto-applied · Simulated capital · T&amp;C apply</div>
    </a>
  );
}
